/**
 * Asynchronously loads the component for Login page
 */
import loadable from '../../utils/loadableModal';
export default loadable(() =>{

    return new Promise(resolve => {
        setTimeout(() => resolve(import("./index" /* webpackChunkName: "Login" */)), 100);
      });
});
